export const Wordmark = ({ className = "", tone = "ink" }) => (
  <span className={`relative inline-flex flex-col font-wide leading-[0.82] ${tone === "cream" ? "text-dano-cream" : "text-dano-ink"} ${className}`}>
    <span>DANO</span>
    <span>BARS</span>
    <svg viewBox="0 0 120 14" className="mt-[0.12em] h-[0.5em] w-[3.8em] text-dano-red" fill="none" aria-hidden="true">
      <path d="M2 4 C 35 11, 80 11, 114 4" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
      <path d="M106 1 L115 4 L110 12" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </span>
);
